<!-- <mat-form-field class="w-100-p custom-phone-ctrl" [appearance]="appearance">
    <mat-label>{{ label | translate }}</mat-label>
    <input [pattern]="swissPhoneNumberPattern" matInput [formControl]="inputField" [required]="isRequired"
        [imask]="{mask: '+{41} 00 000 00 00'}"  [unmask]="'typed'"
        placeholder="{{ placeholder | translate }}" [disabled]="isDisabled" />
        <mat-icon *ngIf="suffixIconName" matSuffix>{{suffixIconName}}</mat-icon>
        <mat-error *ngIf="isRequired || swissPhoneNumberPattern">
            <span *ngIf="isRequired && inputField.touched && !inputField.value?.length">{{'ERR_MSG_REQUIRED'|translate}}</span>
            <span *ngIf="swissPhoneNumberPattern &&  inputField?.errors?.pattern">
                {{"Invalid PhoneNumber"}}
            </span>
            
        </mat-error>
</mat-form-field> -->
<!-- {{inputField.value}} | {{inputField.errors | json}} -->

<!-- [dropSpecialCharacters]="false" mask="+00 00 000 00 00" -->

<!-- [imask]="{mask: '+{41} 00 000 00 00'}"  [unmask]="false" [prefix]="" -->
<!-- <button mat-button class="mb-20" (click)="inputField.markAsTouched();">
touch
</button> -->


<div fxLayout="column">
    <div fxFlex="100%" fxLayout="column" class="phone-outline mb-24">
        <mat-label class="phone-outline-label">{{
            label | translate
            }} 
            <span *ngIf="isRequired">*</span>
        </mat-label>
        <div fxFlex="100%" class="phone-outline-box"
            [ngClass]="{'phone-outline-box-invalid' : (inputField.errors) && (!control.pristine || control.touched) }">
            <!-- <div class="hour-picker" fxFlex="100"> -->
                <!-- <international-phone-number  [formControl]="inputField" placeholder="{{ label | translate }}"
                    [maxlength]="20" [required]="isRequired" [defaultCountry]="defaultCountryOfPhoneNumber"
                    [disabled]="isDisabled" [readonly]="isDisabled"
                    name="phone_number" ></international-phone-number> -->
<!-- 
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>{{label | translate}}</mat-label> -->
                        <input type="tel" class="w-100-p" matInput [id]="inputElId" [required]="isRequired" (countrychange)="onCountryChange($event)" [formControl]="inputField" placeholder="{{placeholder | translate}}" (keypress)="onKeyPress($event)">
                        <!-- <input type="tel" class="w-100-p" matInput [id]="inputElId" [required]="isRequired"  [formControl]="inputField" placeholder="{{placeholder | translate}}" (keypress)="onKeyPress($event)"> -->

                        <!-- <mat-error *ngIf="inputField.hasError('required') && !isOverlayOpen">{{'*required!'}}</mat-error>
                        <mat-error *ngIf="inputField.hasError('invalid-number') && !isOverlayOpen">{{telInputErrorMsg}}</mat-error>
                      </mat-form-field> -->

                    <!-- <international-phone-number *ngIf="this.inputField.value" [formControl]="inputField" placeholder="{{ label | translate }}"
                    [maxlength]="20" [required]="isRequired" 
                    name="phone_number"></international-phone-number> -->
            <!-- </div> -->
        </div>
    </div>
    <div *ngIf="inputField.errors && (!control.pristine || control.touched)"
        class="error-msg error-msg-color help-block font-size-12">
        <span *ngIf="control.hasError('required')">{{ "ERR_MSG_REQUIRED" | translate
            }}</span>
            <span *ngIf="control.hasError('invalid-number')">{{ invalidErrorMessage | translate }}</span>

        <!-- <ng-template #invalidTemplate>
            <span>{{ invalidErrorMessage | translate }}</span>
        </ng-template> -->

    </div>
</div>